import { IonToolbar } from '@ionic/react'
import { useHistory } from 'react-router'
import claroLogo from '../../assets/images/claro.png'
import idValidationError from '../../assets/images/idValidationError.svg'
import { useAppContext } from '../../context/AppContext'
import Button from '../Button'

const OBDValidationError = () => {
  const procedure = location.pathname.substring(location.pathname.lastIndexOf('/') + 1)
  const history = useHistory()
  const { setBlockNavigation }: any = useAppContext()
  const onContinue = () => {
    history.push(`/procedures/${procedure}`)
    setBlockNavigation(false)
  }
  return (
    <main className="landing">
      <header id="procedure-toolbar">
        <IonToolbar>
          <img src={claroLogo} alt="back page button" className="max-height-22 ion-padding-start" />
        </IonToolbar>
      </header>
      <div className="landing-container">
        <img
          id="data-confirmation-img-valid-ok"
          alt="finished activation"
          src={idValidationError}
          style={{ maxHeight: '160px' }}
        />
        <h4>
          <strong id="nueva-portabilidad-strong-felicitaciones">
            No pudimos validar <br />
            la identidad del cliente
          </strong>
        </h4>
        <p className="obd-recommendations">
          Verificá los datos del documento, <br />
          su vencimiento y mayoría de edad <br />e intentá nuevamente.
        </p>
        <Button
          id="prepaga-success-back-to-start"
          className="submit-button"
          handleSubmit={onContinue}
          label="Volver al inicio"
        />
      </div>
    </main>
  )
}

export default OBDValidationError
